import React from "react";
import { useSelector } from "react-redux";
import targetGroupType from "../../../../shared/enums/targetGroupType";
import { gradesList } from "../../../../shared/enums/gradesEnum";
import Tag from "../../../../shared/components/ui/tag/Tag";

const BADGE_COLORS = {
    [targetGroupType.Everyone]: { color: "#6e6e09", backgroundColor: "#ffffd0" },
    [targetGroupType.Teacher]: { color: "#2e6e09", backgroundColor: "#d3ffd0" },
    [targetGroupType.Student]: { color: "#09406e", backgroundColor: "#d0f1ff" },
};

const TargetBadge = ({ filters }) => {
    const { texts } = useSelector(state => state.translate);

    const getType = (filters) => {
        const hasTeacher = filters.some(f => f.targetGroupTypeId === targetGroupType.Teacher);
        const hasStudent = filters.some(f => f.targetGroupTypeId === targetGroupType.Student);
        const hasEveryone = filters.some(f => f.targetGroupTypeId === targetGroupType.Everyone);
        if (hasEveryone || (hasTeacher && hasStudent))
            return targetGroupType.Everyone;
        if (hasTeacher)
            return targetGroupType.Teacher;
        if (hasStudent)
            return targetGroupType.Student;
        return targetGroupType.Everyone;
    };

    const getBadgeLabels = (filters, texts) => {
        switch (getType(filters)) {
            case targetGroupType.Teacher:
                return [texts.teachers];
            case targetGroupType.Student: {
                const gradeFilters = filters.filter(f => f.targetGroupTypeId === targetGroupType.Student && f.grade != null);
                if (gradeFilters.length > 0 && gradeFilters.length < gradesList.length)
                    return gradeFilters
                        .map(f => gradesList.find(g => g.value === f.grade)?.label.replace("כל ", "") ?? "")
                        .filter(Boolean);
                return [texts.students];
            }
            default: return [texts.allSchool];
        }
    };

    const type = getType(filters);
    const { color, backgroundColor } = BADGE_COLORS[type];


    return getBadgeLabels(filters, texts).map((label, i) => (
        <Tag key={i} label={label} color={color} backgroundColor={backgroundColor} />
    ));
};

export default TargetBadge;
